<markant-dialog [open]="true" [headTitle]="headline" (close)="closeDialog()">
  <p class="p-with-line-breaks">{{ text }}</p>
  <div slot="footer">
    <div class="buttonFlex" *ngIf="showConfirmButton">
      <markant-button colorScheme="primary" (click)="submitDialog()">{{
        buttonText
      }}</markant-button>
    </div>
  </div>
</markant-dialog>
